// Module
var code = "<div class=\"count-chart\"> <ul v-for=\"row in counts\"> <li v-for=\"c in row\"> <component :is=\"interactive ? 'a' : 'div'\" href=\"#\" @click.stop.prevent=\"dataClick(c)\"> <span class=\"number\" :style=\"{ color: c.color }\">{{ c.count }}</span> <span class=\"label\">{{ c.label }}</span> </component> </li> </ul> </div> ";
// Exports
export default code;